import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-zero-view',
  templateUrl: './zero-view.component.html',
  styleUrls: ['./zero-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ZeroViewComponent {
  @Input() datasource;

  public openWordpressPlugin() {
    const url = 'https://wordpress.org/plugins/Triggerbee';
    window.open(url, '_blank');
  }
}
